



































































import Vue from 'vue';
import Vue2Filters from 'vue2-filters';
import {
  LControlAttribution,
  LControlLayers,
  LControlScale,
  LControlZoom,
  LIcon,
  LLayerGroup,
  LMap,
  LMarker,
  LPopup,
  LTileLayer,
  LTooltip,
} from 'vue2-leaflet';
import axios from 'axios';
import { ReportSpec } from '@/components/ReportControls.vue';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAutorenew } from '@mdi/js';
import { DateTime } from "luxon";

Vue.use(Vue2Filters);

const tileProviders = [
  {
    name: 'OpenStreetMap',
    visible: true,
    attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  },
];

export default Vue.extend({
  name: 'PostCodesMapTile',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LLayerGroup,
    LTooltip,
    LPopup,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LControlLayers,
    LIcon,
    SvgIcon,
  },
  props: {
    spec: Object as () => ReportSpec,
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      if (this.spec?.dateStyle == "calendar") {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-postcodes/${depot}/${DateTime.fromJSDate(from).toISODate()}/${DateTime.fromJSDate(to).toISODate()}/`;
      } else {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-postcodes/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
      }
    },
    postcodesUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      if (this.spec?.dateStyle == "calendar") {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-top-postcodes/${depot}/${DateTime.fromJSDate(from).toISODate()}/${DateTime.fromJSDate(to).toISODate()}/`;
      } else {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-top-postcodes/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
      }
    },
  },
  data() {
    return {
      path: mdiAutorenew,
      size: 48,
      loading: true,
      index: null,
      center: [53.790156, -2.259284],
      tileProviders,
      layersPosition: 'topright',
      zoom: 6,
      mapOptions: {
        attributionControl: false,
        zoomSnap: true,
        zoomControl: true,
      },
      regionMarkers: {},
      postcodeMarkers: {},
      icon: ({
        iconSize: [32, 32],
      }),
      iconSize: [32],
    };
  },
  methods: {
    alert(item: object) {
      alert('this is ' + JSON.stringify(item));
    },
  },
  watch: {
    spec: {
      immediate: true,
      async handler() {
        const dataResponse = await axios.get<{
          regional_data: [{
            region: string, count: number, position: {
              lat: number, lng: number
            }, county: string
          }],
        }>(this.dataUrl, { params: { account_codes: this.spec.accountCodes.flatMap((a) => a.codes) } });
        this.regionMarkers = dataResponse.data.regional_data;
        this.loading = false;

        const postcodesResponse = await axios.get<{
          top_postcodes: [{
            postcode: string, count: number, position: {
              lat: number, lng: number
            }, county: string
          }],
        }>(this.postcodesUrl, { params: { account_codes: this.spec.accountCodes.flatMap((a) => a.codes) } });
        this.postcodeMarkers = postcodesResponse.data.top_postcodes;
      },
    },
  },
});
